import { useState, type ReactNode, type FC } from 'react';
import SearchBlockContext, { type SearchBlockContextProps, type SearchBlockProps } from './SearchBlockContext';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';

interface SearchBlockProviderProps extends SearchBlockProps {
    children: ReactNode;
}

const SearchBlockProvider: FC<SearchBlockProviderProps> = ({
    listing,
    children,
    ...restProps
}) => {
    const activeFiltersInitialValue = getActiveFiltersFromURL(listing.filters);
    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);

    const [page, setPage] = useState(getPageFromURL());

    const providerValue: SearchBlockContextProps = {
        activeFilters,
        setActiveFilters,
        page,
        setPage,
        listing,
        ...restProps,
    };

    return (
        <SearchBlockContext.Provider value={providerValue}>
            {children}
        </SearchBlockContext.Provider>
    );
};

export default SearchBlockProvider;
